export function encodeBase64(value) {
  const utf8Bytes = new TextEncoder().encode(value);

  let binary = "";
  for (const byte of utf8Bytes) {
    binary += String.fromCodePoint(byte);
  }

  return btoa(binary);
}

export function decodeBase64(base64) {
  const binary = atob(base64);

  const bytes = Uint8Array.from(
    binary,
    char => char.codePointAt(0)
  );

  return new TextDecoder().decode(bytes);
}